module.exports = __webpack_public_path__ + "img/nopullnew.d7ab63b2.png";